export default "../img/bg-modal-blocks.png";